import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
